import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.tsx';
import { forgetExpiredKeys } from './lib/keystore.js';
import './styles.css';
import './styles/chat.css';

/**
 * Application entry point.
 *
 * Nothing is loaded from a remote origin here — no analytics, no error
 * reporter, no tag manager. Concept §5 requires conversation pages to carry no
 * third-party scripts that could read the fragment or plaintext, and the
 * simplest way to guarantee that is to ship none anywhere.
 */

const container = document.getElementById('root');
if (!container) throw new Error('Root element is missing.');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);

// Clients remove locally stored conversation keys when they observe expiry, on
// a best-effort basis (concept §7).
void forgetExpiredKeys();

// Installable PWA behaviour (concept §2). The worker caches the application
// shell only and never touches conversation data.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/service-worker.js').catch(() => {
      // A failed registration only costs offline start-up; the app still works.
    });
  });
}
